import { graphql } from "../gql";

const getHeadToHeadPlayerGameStatsQuery = graphql(`
  query GetHeadToHeadPlayerGameStats($input: PlayerNodeInput!) {
    player(input: $input) {
      name
      teamInfo {
        numberFireId
      }
      gameStats {
        ... on QBPlayerStats {
          passAttempts
          passTDs
          passYards
          event {
            numberfireId
            homeTeam {
              numberfireId
            }
          }
        }
        ... on RecPlayerStats {
          receptions
          recTDs
          recYards
          event {
            numberfireId
            homeTeam {
              numberfireId
            }
          }
        }
        ... on RBPlayerStats {
          rushTDs
          rushYards
          rushes
          event {
            numberfireId
            homeTeam {
              numberfireId
            }
          }
        }
        ... on KPlayerStats {
          fgMade
          totalPoints
          xpMade
          event {
            numberfireId
            homeTeam {
              numberfireId
            }
          }
        }
        ... on DSTPlayerStats {
          ints
          sacks
          tacklesForLoss
          event {
            numberfireId
            homeTeam {
              numberfireId
            }
          }
        }
      }
    }
  }
`);

export default getHeadToHeadPlayerGameStatsQuery;
